// =====================================================================
//  Google Reviews data
//  ---------------------------------------------------------------------
//  Feeds the Google review section on the homepage
//  (sections/home/home-google-reviews.tsx).
//
//  The reviews below are REAL reviews pulled word-for-word from the
//  Mystic Media Film Google Business Profile (5.0 stars, 73 reviews)
//  on 2026-05-22. Reviewer photos are the live Google profile images.
//
//  To add/remove a review: copy the reviewer name, star rating, date,
//  and text verbatim from the Google profile into an entry below.
//  Photo: paste the Google photo URL, or save an image into
//  public/reviews/<name>.jpg and use '/reviews/<name>.jpg'. If `photo`
//  is omitted the card shows the reviewer's initials.
// =====================================================================

export interface GoogleReview {
  id: string;
  name: string;
  /** Reviewer photo. Full URL or local path (/reviews/x.jpg). */
  photo?: string;
  /** Whole-star rating, 1-5. */
  rating: number;
  /** Google-style relative time, e.g. "5 months ago". */
  date: string;
  /** The review, word-for-word. */
  text: string;
}

export const googleReviewSummary = {
  /** Overall star rating shown next to the Google logo. */
  rating: 5.0,
  /** Total number of Google reviews on the profile. */
  totalReviews: 73,
  /** Opens the Google "write a review" dialog. */
  writeReviewUrl: 'https://g.page/r/CVhC0OMfu9ocEAI/review',
  /** "View all Google reviews" link — the full Google profile. */
  viewAllUrl: 'https://g.page/r/CVhC0OMfu9ocEAI',
};

// ---------------------------------------------------------------------
//  Real Google reviews (6 selected for the homepage grid).
// ---------------------------------------------------------------------
export const googleReviews: GoogleReview[] = [
  {
    id: 'jeremy-norwood',
    name: 'JEREMY NORWOOD',
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLqAuaNfHPM94Z2N1D5gT51fyVqU1qvvsE9EN9itTktbI-eOQ=w120-h120-p-rp-mo-br100',
    rating: 5,
    date: '5 months ago',
    text: `The team demonstrates exceptional expertise in both website design and functionality. They consistently provided thorough and accurate answers to all inquiries from our company. Their delivery of a fully operational website was rapid and efficient, and they exhibited notable agility in implementing requested modifications promptly. Furthermore, they proactively outlined our future digital requirements and assisted in developing a strategic roadmap for the website's long-term evolution. I highly recommend their services.`,
  },
  {
    id: 'austin-taylor',
    name: 'Austin Taylor',
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIVozpjyg2Fy1CHzngYkPyFfUvPMeNvCLOyICw94GiAsFoBug=w120-h120-p-rp-mo-br100',
    rating: 5,
    date: 'a year ago',
    text: `We recently worked with Mystic Media Film on a video project and couldn't be happier with the results. From the first meeting, it was clear they really cared about understanding our brand and what we were trying to achieve.

They helped us with video production, some updates to our website design, and even gave advice on social media content. Everything felt really organized and professional without being overwhelming.

The final video came out better than we imagined—clean, creative, and it told our story exactly the way we wanted. Our website also looks sharper and loads much faster now, which has made a difference.

If you're looking for a media company in Houston that knows their stuff when it comes to videography, web design, and digital content creation, I definitely recommend Mystic Media Film. They're easy to work with, they listen, and they deliver solid work.`,
  },
  {
    id: 'richard-gomez',
    name: 'Richard Gomez',
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKBVwQsJYtr-renmHNJ7mmNJGdywyqkPiUu7aiHoUbgHabliQ=w120-h120-p-rp-mo-br100',
    rating: 5,
    date: '2 years ago',
    text: `Anthony is by far the best media manager and photographer I have ever worked with. Definitely impressed with what he has done for our business. If you are reading this, quit wasting your time scrolling through reviews and give him a call! His services are worth every dime!`,
  },
  {
    id: 'ej-marine',
    name: 'EJ Marine',
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjU3OMAO9toOPTZyOjKWZR206wBg829B5VBttP6hLo_wqrKq_7eQ=w120-h120-p-rp-mo-ba2-br100',
    rating: 5,
    date: '2 years ago',
    text: `I met with Mystic Media and had a chance to review their portfolio of work and I was very impressed. The presentation was clear, the production and editing was flawless, and their knowledge of the industry is unparalleled. I decided to work with them and I have been impressed repeatedly with the quality of work. I have the ability to see and track data which I have noticed an immediate increase in numbers for my business. I strongly recommend Mystic Media for any who is looking to increase traffic as well as revenue for their business!`,
  },
  {
    id: 'mentality',
    name: 'Mentality',
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVS6eJukObc8rB6EAJ0FeJrb6SZJl-hLgWGldKaACvm7VyMVsFu=w120-h120-p-rp-mo-br100',
    rating: 5,
    date: '2 years ago',
    text: `Mystic Media Film in Houston, Texas, exceeded my expectations for video production. Their team's expertise shone through in every aspect, from conceptualizing to filming. They adeptly handled the unique challenges of Houston's dynamic environment, producing a visually stunning and impactful video. Their attention to detail, creativity, and technical skill were remarkable. Communication was seamless, and their commitment to customer satisfaction was evident. For anyone seeking top-tier video production in Houston, Mystic Media Film is the go-to choice. Their professionalism and high-quality output make them stand out in the industry.`,
  },
  {
    id: 'samantha-mesa',
    name: 'Samantha Mesa',
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJID0D9OtZg-Tox-afJaODkbQuaIbmSKFJbHk86IuRwbeWm-w=w120-h120-p-rp-mo-br100',
    rating: 5,
    date: '2 years ago',
    text: `I had an amazing experience with Mystic Media Film for my headshots! Their professionalism and attention to detail were outstanding. They were time-sensitive and delivered exceptional results promptly. The team's expertise and guidance helped capture my unique personality perfectly. I highly recommend Mystic Media Film for anyone in need of professional photography services. Five stars all the way!`,
  },
  {
    id: 'inderdeep-bajwa',
    name: 'Inderdeep Bajwa',
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUTRRr-rd_75vXRzdiD6xkGb6i7vyDekvsqrNU8NwOLAFRQB7X9=w120-h120-p-rp-mo-ba3-br100',
    rating: 5,
    date: '2 years ago',
    text: `Had a wonderful experience taking media services from Mystic Media Film. They went above and beyond to help me out with the consultation and shooting a media project. The owner was generous with his time, open to discussions, and explained things in great details. He not just cared about what my needs are but also made sure that I am putting my money into something that will actually be useful to me.

I must say, the experience far exceeded my expectations. Their attention to detail was evident in every shot, every edit, and every piece of feedback they provided. They even run a non-profit called Creative Terminal to educate media and content professionals.`,
  },
  {
    id: 'yisue-delgado',
    name: 'Yisue Delgado',
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWP8OL8eUSPLYUOM8AVjFW4kZeL_kTiuZMSDEcBFKSrvp68Bcw=w120-h120-p-rp-mo-br100',
    rating: 5,
    date: '2 years ago',
    text: `In my experience with Mystic Media Film in Houston, Texas, their proficiency in video production was clearly evident. The team displayed remarkable creativity and technical acumen, perfectly capturing the essence of my project. Their ability to blend their skills with the unique Houston backdrop was impressive. Each step, from planning to execution, was handled with utmost professionalism and clear communication. The final video exceeded my expectations, showcasing their exceptional talent and attention to detail. Mystic Media Film is a top recommendation for anyone in Houston looking for superior video production services. Their dedication to quality and client satisfaction is unparalleled.`,
  },
];
